export function isReviewableVideo(video) {
  const status = String(video?.status || video?.processingStatus || '').toLowerCase();
  if (video?.deleted || video?.isDeleted || video?.deletedAt || ['deleted', 'deleting', 'failed', 'recording'].includes(status)) return false;
  return Boolean([
    video?.videoURL, video?.videoUrl, video?.url, video?.downloadURL, video?.downloadUrl,
    video?.mediaURL, video?.storagePath, video?.finalStoragePath, video?.videoStoragePath, video?.mediaStoragePath,
  ].some(value => typeof value === 'string' && value.trim()) || video?.playbackMode === 'segment_playlist');
}

export function notificationHasLiveVod(item, teamId, videos, matches) {
  const payload = item.payload || {};
  let targetTeam = item.teamId || payload.teamId;
  let mapId = item.mapId || payload.mapId;
  let videoId = item.videoId || payload.videoId;
  const matchId = item.reviewMatchId || payload.reviewMatchId;
  try {
    const url = new URL(item.payloadUrl || item.url || payload.url || '', 'https://valovate.com');
    const route = url.hash.startsWith('#/') ? new URL(url.hash.slice(1), url.origin) : url;
    const parts = route.pathname.split('/').filter(Boolean).map(decodeURIComponent);
    targetTeam ||= route.searchParams.get('teamId') || route.searchParams.get('team');
    if (parts[0] === 'review' && parts.length === 3) {
      mapId ||= parts[1];
      videoId ||= parts[2];
    }
  } catch (_) { /* Unknown links are not evidence of a deleted VOD. */ }
  if (targetTeam !== teamId || !mapId) return true;
  if (videoId) return videos.some(video => video.mapId === mapId && video.id === videoId);
  if (matchId) return matches.some(match => match.mapId === mapId && match.id === matchId);
  return true;
}
